export default __webpack_public_path__ + "static/media/triangle.4b3b7e59.svg";